module.exports = __webpack_public_path__ + "img/pic1.aab21169.png";